import classNames from "./InviteBotHelpDialog.module.css";
import { Image } from "@fluentui/react-components";
import * as teams from "@microsoft/teams-js";
import Button from "../common/Button";

export default function InviteBotHelpDialog() {
  return (
    <div className={classNames.InviteBotHelpDialog}>
      <h2>
        At the top of your Teams window, click "More" and select "Meeting Info"
      </h2>
      <Image src={"invite-bot-help/screenshot-1.png"} />
      <h2>Then click "Copy Join Info"</h2>
      <Image src={"invite-bot-help/screenshot-2.png"} />
      <Button onClick={() => teams.dialog.url.submit()}>Got it</Button>
    </div>
  );
}
